var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "telnyx-user-mapping" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", icon: "user" },
                on: {
                  click: function ($event) {
                    _vm.showUserPicker = true
                  },
                },
              },
              [_vm._v("\n                Kullanıcı Değiştir\n            ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "current-user-section" }, [
        _c("div", { staticClass: "section-title" }, [_vm._v("Mevcut Atama")]),
        _vm._v(" "),
        _vm.currentUser
          ? _c("div", { staticClass: "user-card" }, [
              _c(
                "div",
                { staticClass: "user-info" },
                [
                  _c("a-avatar", { attrs: { size: 64 } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getUserInitials(_vm.currentUser)) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-details" }, [
                    _c("div", { staticClass: "user-name" }, [
                      _vm._v(_vm._s(_vm.currentUser.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-email" }, [
                      _vm._v(_vm._s(_vm.currentUser.email)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "user-phone" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(
                            _vm.value,
                            "payload.callerPhoneNumber",
                            "Numara tanımlı değil"
                          )
                        )
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-actions" },
                [
                  _vm.currentUser._id ===
                  _vm.$_.get(_vm.value, "payload.userId", null)
                    ? _c("a-tag", { attrs: { color: "green" } }, [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            staticStyle: {
                              "font-size": "14px",
                              "margin-right": "4px",
                            },
                          },
                          [_vm._v("check_circle")]
                        ),
                        _vm._v("\n                    Aktif\n                "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { type: "danger", size: "small" },
                      on: { click: _vm.removeUserMapping },
                    },
                    [
                      _vm._v(
                        "\n                    Eşlemeyi Kaldır\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _c("div", { staticClass: "no-user-assigned" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "no-user-text" },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Kullanıcı Atanmamış"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "subtitle" }, [
                    _vm._v("Bu Telnyx numarası henüz hiç kimseye atanmamış"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-top": "16px" },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showUserPicker = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Kullanıcı Ata\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "channel-info-section" }, [
        _c("div", { staticClass: "section-title" }, [
          _vm._v("Kanal Bilgileri"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-grid" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Kanal Adı")]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.value.name)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Telefon Numarası")]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(
                _vm._s(
                  _vm.$_.get(
                    _vm.value,
                    "payload.callerPhoneNumber",
                    "Numara tanımlı değil"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Username")]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(
                _vm._s(
                  _vm.$_.get(
                    _vm.value,
                    "payload.username",
                    "Kullanıcı tanımlı değil"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Domain")]),
            _vm._v(" "),
            _c("div", { staticClass: "value" }, [
              _vm._v(
                _vm._s(
                  _vm.$_.get(
                    _vm.value,
                    "payload.domain",
                    "Domain tanımlı değil"
                  )
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Kullanıcı Seç",
            confirmLoading: _vm.saving,
            width: "800px",
          },
          on: { ok: _vm.handleUserSelection, cancel: _vm.cancelUserSelection },
          model: {
            value: _vm.showUserPicker,
            callback: function ($$v) {
              _vm.showUserPicker = $$v
            },
            expression: "showUserPicker",
          },
        },
        [_c("UserPicker", { on: { "user-selected": _vm.onUserSelected } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Kullanıcı Eşleme")]),
      _vm._v(" "),
      _c("p", [_vm._v("Bu Telnyx numarasını kullanacak kullanıcıyı seçin")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-user-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("person_off")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }